import { render, staticRenderFns } from "./ProductSingleDropdown.vue?vue&type=template&id=7ef35d1b&"
import script from "./ProductSingleDropdown.vue?vue&type=script&lang=js&"
export * from "./ProductSingleDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports